import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import type { ChatCustomerAction } from "./types";

export interface ChatCustomerActionChipsProps {
  actions: ChatCustomerAction[];
  className?: string;
  /** Softer palette for yellow “sent to customer” notices. */
  tone?: "default" | "notice";
}

export function ChatCustomerActionChips({
  actions,
  className,
  tone = "default",
}: ChatCustomerActionChipsProps) {
  const { t } = useTranslation("handshakePages");

  if (actions.length === 0) {
    return null;
  }

  return (
    <div
      className={cn(
        "mt-2 flex flex-wrap items-center justify-center gap-2",
        className,
      )}
    >
      {actions.map((action) => {
        const label =
          action.kind === "cancel"
            ? t("customerActionCancel")
            : t("customerActionReceipt");
        return (
          <a
            key={action.url}
            href={action.url}
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
              "inline-flex items-center justify-center rounded-full border px-3.5 py-1.5 text-[13px] font-semibold transition-colors",
              tone === "notice"
                ? "border-warning-400 bg-surface-0/90 text-warning-900 hover:bg-surface-0"
                : "border-surface-300 bg-surface-0 text-surface-800 hover:border-primary-400 hover:text-primary-700",
            )}
          >
            {label}
          </a>
        );
      })}
    </div>
  );
}
